"use strict";

var _slicedToArray = require("/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/slicedToArray.js");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
var dateFormat_1 = __importDefault(require("../../utils/dateFormat"));
var date_1 = __importDefault(require("../date"));
function isMinAge(value, properties) {
  var minAge = properties.minAge;
  if (!value) {
    return new classes_1.ValidationResult(true);
  }
  if (!date_1.default.run((0, dateFormat_1.default)(value)).isValid) {
    return new classes_1.ValidationResult(false, 'Data inválida');
  }
  var minAgeNumber = typeof minAge === 'string' ? parseInt(minAge) : minAge;
  var today = new Date();
  var dateValues = value.split('/');
  var _dateValues$map = dateValues.map(Number),
    _dateValues$map2 = _slicedToArray(_dateValues$map, 3),
    birthDay = _dateValues$map2[0],
    birthMonth = _dateValues$map2[1],
    birthYear = _dateValues$map2[2];
  var birthDate = new Date(+birthYear, birthMonth - 1, birthDay);
  var age = today.getFullYear() - birthDate.getFullYear();
  var month = today.getMonth() - birthDate.getMonth();
  var isBirthdayThisMonth = month === 0;
  var notPassedBirthdayThisYear = month < 0;
  var isBirthdayToday = today.getUTCDate() < birthDate.getUTCDate();
  if (notPassedBirthdayThisYear || isBirthdayToday && isBirthdayThisMonth) {
    age -= 1;
  }
  var isValid = age >= minAgeNumber;
  return new classes_1.ValidationResult(isValid);
}
exports.default = new classes_1.Validator(isMinAge, {
  minAge: 0
});